import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import JsonLd from "@/components/feature/JsonLd";
import { SITE_URL } from "@/lib/seo";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import CategorySection from "./components/CategorySection";
import WhatIs from "./components/WhatIs";
import WhySection from "./components/WhySection";
import GuidesSection from "./components/GuidesSection";
import FaqSection from "./components/FaqSection";
import Footer from "./components/Footer";

export default function Home() {
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location.hash]);

  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd
        data={{
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: t("nav.brand"),
          url: `${SITE_URL}/`,
          description: t("hero.description"),
          inLanguage: ["en", "pl", "es", "fr"],
        }}
      />
      <JsonLd
        data={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: t("nav.brand"),
          url: `${SITE_URL}/`,
        }}
      />
      <JsonLd
        data={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: [1, 2, 3, 4, 5, 6].map((num) => ({
            "@type": "Question",
            name: t(`faq.q${num}`),
            acceptedAnswer: { "@type": "Answer", text: t(`faq.a${num}`) },
          })),
        }}
      />
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <WhatIs />
        <WhySection />
        <GuidesSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}